import { cn } from '@v2/shared/lib/utils';

/**
 * Shared by input, select, textarea and the phone field so the four cannot drift apart.
 *
 * `leading-6` is pinned rather than inherited because a control's height should be a
 * property of the control, not of the rhythm of the page it lands on. Without it these
 * were 52px on the bulk order form and 56px inside a `prose` article — line-height is
 * inherited, so it leaks past the `not-prose` a form declares. 1.5rem is what they
 * resolve to anywhere prose is not involved, so nothing outside an article moves, and it
 * is also the line-height Tailwind pairs with `text-base`.
 *
 * It is what lets FormSelect state a height at all: see the note there on Chrome
 * refusing a line-height on a closed `<select>`.
 */
export function controlClasses(hasError: boolean, className?: string): string {
  return cn(
    'border-2 border-solid p-3 rounded-md font-medium leading-6',
    hasError ? 'border-red-500 focus:border-red-700' : 'border-slate-300 focus:border-slate-800',
    className
  );
}
